/**
 * Interstitial Clipboard
 *
 * Copy-to-clipboard for coupon codes on interstitial pages.
 * Replaces legacy components/interstitial/copy.js (execCommand) and
 * couponCode.coffee (ZeroClipboard) with the modern Clipboard API.
 *
 * Behavior:
 * - Clicking .clipboard-container copies the code from data-clipboard-text
 * - Updates the .copy-btn text to "Copied!"
 * - If the container has a data-url, redirects after 2 seconds (couponCode behavior)
 */

const REDIRECT_AFTER_COPY_MS = 2000;

async function copyToClipboard(text) {
  if (navigator.clipboard?.writeText) {
    await navigator.clipboard.writeText(text);
  } else {
    const tempInput = document.createElement("input");
    tempInput.type = "text";
    tempInput.value = text;
    document.body.appendChild(tempInput);
    tempInput.select();
    document.execCommand("Copy");
    document.body.removeChild(tempInput);
  }
}

export function initInterstitialClipboard() {
  const copyBtn = document.querySelector(".copy-btn");
  if (!copyBtn) return;

  const redirectUrl = copyBtn.dataset.url;

  copyBtn.addEventListener("click", async () => {
    const promoCode = copyBtn.dataset.clipboardText;
    if (!promoCode) return;

    const originalLabel = copyBtn.getAttribute("label");

    try {
      await copyToClipboard(promoCode);

      copyBtn.setAttribute("label", "Copied!");

      const codeEl = document.querySelector(".-code");
      if (codeEl) {
        codeEl.classList.add("-copied");
      }

      if (redirectUrl) {
        setTimeout(() => {
          window.location.assign(redirectUrl);
        }, REDIRECT_AFTER_COPY_MS);
      }
    } catch {
      copyBtn.setAttribute("label", "Copy failed");
      setTimeout(() => {
        copyBtn.setAttribute("label", originalLabel);
      }, REDIRECT_AFTER_COPY_MS);
    }
  });
}
